import React, { useState } from "react";
import { Modal, Form, Input, Button, Switch, message } from "antd";

const CreateChallengeModal = ({ visible, onClose, onCreate }) => {
  const [form] = Form.useForm();
  const [isCoaching, setIsCoaching] = useState(false); // 난임코칭 토글 상태 추가

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      await onCreate(values);
      form.resetFields();
      setIsCoaching(false); // 상태 초기화
      message.success("새로운 챌린지가 생성되었습니다.");
      onClose();
    } catch (error) {
      message.error("생성에 실패했습니다.");
    }
  };

  return (
    <Modal
      title="새 챌린지 생성"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="challenge_title"
          label="챌린지 제목"
          rules={[{ required: true, message: "챌린지 제목을 입력해주세요." }]}
        >
          <Input />
        </Form.Item>

        {/* 난임코칭 토글 */}
        <Form.Item 
         name="challenge_type"
          label="난임코칭">
          <Switch checked={isCoaching} onChange={setIsCoaching} />
        </Form.Item>

        {/* 주차 입력 필드 (토글이 true일 때만 보임) */}
        {isCoaching && (
          <Form.Item
            name="challenge_week"
            label="주차 입력"
            rules={[{ required: true, message: "주차를 입력해주세요." }]}
          >
            <Input placeholder="예: 5주차" />
          </Form.Item>
        )}

        <Form.Item
          name="challenge_certification"
          label="인증 방식"
          rules={[{ required: true, message: "인증 방식을 입력해주세요." }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="challenge_frequency"
          label="인증 빈도"
          rules={[{ required: true, message: "인증 빈도를 입력해주세요." }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="challenge_daily" label="일일 인증 횟수">
          <Input type="number" />
        </Form.Item>
        <Form.Item name="challenge_participation" label="참여 인원">
          <Input type="number" />
        </Form.Item>
        <Form.Item name="challenge_max" label="최대 참여 인원">
          <Input type="number" />
        </Form.Item>
        <Form.Item name="challenge_auth_cnt" label="최대 인증 횟수">
          <Input type="number" />
        </Form.Item>
        <Form.Item name="challenge_icon" label="챌린지 아이콘 (숫자 입력)">
          <Input type="number" />
        </Form.Item>
        <Form.Item name="challenge_auth_description" label="인증 설명">
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item name="challenge_description" label="챌린지 설명">
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item
          name="challenge_start"
          label="시작일 (YYYY-MM-DD)"
          rules={[{ required: true, message: "시작일을 입력해주세요." }]}
        >
          <Input placeholder="예: 2024-01-01" />
        </Form.Item>
        <Form.Item
          name="challenge_end"
          label="종료일 (YYYY-MM-DD)"
          rules={[{ required: true, message: "종료일을 입력해주세요." }]}
        >
          <Input placeholder="예: 2024-12-31" />
        </Form.Item>
        <Form.Item
          name="is_private"
          label="비공개"
          valuePropName="checked"
          initialValue={false}
        >
          <Switch />
        </Form.Item>
        <Form.Item name="challenge_weekly_auth" label="주 인증 최대 횟수">
          <Input type="text" />
        </Form.Item>
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            onClick={handleCreate}
            style={{ marginRight: 8 }}
          >
            생성
          </Button>
          <Button onClick={onClose}>취소</Button>
        </div>
      </Form>
    </Modal>
  );
};

export default CreateChallengeModal;
